import { Flex, Icon, Stack, Text } from '@chakra-ui/react';
import {
  GiCampingTent,
  GiForestCamp,
  GiPalmTree,
  GiTicket,
} from 'react-icons/gi';
import { BsPassport } from "react-icons/bs";
import { MdMapsHomeWork } from "react-icons/md";



import { HiOutlineClock } from 'react-icons/hi';
import { IoMdHome } from 'react-icons/io';
import { MdTour } from 'react-icons/md';
import { FaPassport } from 'react-icons/fa';
import { shallow } from 'zustand/shallow';
import { toTitleCase } from '#utils';
import { useUIStore } from '#store';
import { NON_SELECTABLE_TYPES } from '#constants';

function SuggestRowIcon(props) {
  const { rectype } = props;
  const style = {
    mx: 1.5,
    boxSize: 7,
  };
  if (rectype === 'campground') {
    return <Icon as={GiCampingTent} color="green" {...style} />;
  } else if (rectype === 'permit') {
    return <Icon as={GiTicket} color="olive" {...style} />;
  } else if (rectype === 'recarea') {
    return <Icon as={GiForestCamp} color="orange" {...style} />;
  } else if (rectype === 'tour') {
    return <Icon as={MdTour} color="orange" {...style} />;
  } else if (rectype === 'hotel') {
    return <Icon as={IoMdHome} color="orange" {...style} />;
  } else if (rectype === 'timedentry_tour') {
    return <Icon as={HiOutlineClock} color="orange" {...style} boxSize={6} />;
  } else if (rectype === 'visa_appointment') {
    return <Icon as={BsPassport} color="secondary.300" {...style} boxSize={6} />;
  } else if (rectype === 'embassy') {
    return <Icon as={MdMapsHomeWork} color="secondary.300" {...style} />;
  } else {
    return <Icon as={GiPalmTree} color="orange.600" {...style} />;
  }
}

function handleEquipmentChange(setEquipmentType, outing) {
  if (
    outing.crawlerType === 'parks-canada-v2' ||
    outing.crawlerType === 'parks-canada-v2-permits'
  ) {
    setEquipmentType('Small Tent');
  } else {
    setEquipmentType('Tent');
  }
}

export default function SuggestRow(props) {
  const { name, isChild, type, outing, selectableOuting } = props;
  const {
    searchInput,
    selectOuting,
    outing: currentOuting,
    setEquipmentType,
  } = useUIStore(
    (state) => ({
      searchInput: state.searchInput,
      outing: state.outing,
      selectOuting: state.selectOuting,
      setEquipmentType: state.setEquipmentType,
    }),
    shallow
  );
  const { state_code } = outing;
  const title = isChild || !state_code ? name : `${name}, ${state_code}`;
  const fontWeight = isChild ? 'normal' : 'semibold';
  const outingToSelect = selectableOuting || outing;
  const isNotSelectable =
    NON_SELECTABLE_TYPES.indexOf(type) > -1 && !isChild && !selectableOuting;

  const onRowClick = (e) => {
    if (isNotSelectable) {
      // Don't make top level types clickable
      // Keep the dropdown open
      e.preventDefault();
    } else {
      selectOuting({
        selectedOuting: outingToSelect,
        searchInput,
        name: selectableOuting ? selectableOuting.name : name,
      });
      // We might have to change the equipmentType also
      if (outingToSelect.crawlerType !== currentOuting.crawlerType) {
        // Now let's change the equipmentType
        handleEquipmentChange(setEquipmentType, outingToSelect);
      }
    }
  };
  return (
    <Flex
      align="center"
      direction="row"
      grow={0.1}
      p={1}
      pl={isChild ? 8 : 0}
      _hover={{
        background: isNotSelectable ? 'white' : 'blackAlpha.100',
        cursor: isNotSelectable ? 'not-allowed' : 'default',
      }}
      onMouseDown={onRowClick}
    >
      <SuggestRowIcon rectype={type} />
      <Stack spacing={0}>
        <Text color={isChild ? 'gray.800' : 'gray.700'} fontWeight={fontWeight}>
          {toTitleCase(title)}
        </Text>
        {/* {parent_name && (
          <Text fontSize="xs" color="gray.600">
            {toTitleCase(entity_type)}, {toTitleCase(parent_name)}
          </Text>
        )} */}
      </Stack>
    </Flex>
  );
}
